import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _Promise from "@babel/runtime-corejs3/core-js/promise";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import BrokerageTabLoader from "./brokerage-tab-loader";
import MaterialInput from "@Shared/components/inputs/material-input";
import AgentsSelect from "@Broker/@Modules/agents/components/agents-select";
import ClipboardJS from "clipboard";
import PermissionsMixin from "../../mixins/permissions-mixin";
import { mapActions, mapState, mapMutations } from "vuex";
import { LOAD_AGENTS } from "@Broker/@Modules/agents/store/agent-actions";
import { SET_BROKERAGE_SUBDOMAIN } from "@Broker/@Modules/main/store/account/account-mutations";
import { LOAD_BROKERAGE_DATA, UPDATE_BROKERAGE_DATA } from "../../store/settings-actions";
import { delay } from "@Shared/@Utils/utils";
import { validationMixin } from "vuelidate";
import { maxLength, minLength, required } from "vuelidate/lib/validators";
import { validSubdomain } from "@Shared/@Utils/validation-rules";
import { showToast } from "@Shared/@Utils/constants";
import { cloneDeep, isEqual } from "lodash";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "BrokerageTab",
  components: {
    AgentsSelect,
    MaterialInput,
    BrokerageTabLoader
  },
  mixins: [PermissionsMixin, validationMixin],
  props: {
    saving: {
      type: Boolean,
      required: true
    },
    settingsType: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      loading: false,
      linkCopied: false,
      initialBrokerageData: {},
      localBrokerageData: {
        subdomain: "",
        defaultAgent: "",
        firmLicenseId: ""
      }
    };
  },
  validations: {
    localBrokerageData: {
      subdomain: {
        required,
        minLength: minLength(3),
        maxLength: maxLength(15),
        validSubdomain
      },
      defaultBrokerageAgent: {
        required
      }
    }
  },
  computed: _objectSpread(_objectSpread({}, mapState("SettingsStore", ["brokerageData"])), {}, {
    isValid() {
      return !this.$v.$invalid;
    },
    isDirty() {
      return !isEqual(this.initialBrokerageData, this.localBrokerageData);
    },
    allowSave() {
      return this.isValid && this.isDirty;
    },
    domain() {
      return this.$options.filters.portalDomain("broker", "false");
    }
  }),
  watch: {
    allowSave: {
      handler(value) {
        this.$emit("allow-save", value);
      },
      immediate: true
    },
    saving(value) {
      if (!value) return;
      this.saveBrokerageData();
    }
  },
  async mounted() {
    this.loading = true;
    const promises = [this.LOAD_BROKERAGE_DATA(), this.LOAD_AGENTS()];
    await _Promise.all(promises);
    this.$set(this, "localBrokerageData", cloneDeep(this.brokerageData));
    this.$set(this, "initialBrokerageData", cloneDeep(this.localBrokerageData));
    this.$v.$reset();
    this.loading = false;
    this.initClipboard();
  },
  methods: _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, mapActions("SettingsStore", [LOAD_BROKERAGE_DATA, UPDATE_BROKERAGE_DATA])), mapActions("AgentStore", [LOAD_AGENTS])), mapMutations("AccountStore", [SET_BROKERAGE_SUBDOMAIN])), {}, {
    initClipboard() {
      const clipboard = new ClipboardJS("#copy-link", {
        text: () => {
          return `${this.domain}${this.brokerageData.subdomain}`;
        }
      });
      clipboard.on("success", async () => {
        await delay(2000);
        this.linkCopied = false;
      });
    },
    copyLink() {
      this.linkCopied = true;
    },
    handleChangeAgent(agent) {
      this.localBrokerageData.defaultBrokerageAgent = agent.id;
    },
    async saveBrokerageData() {
      try {
        if (!this.isValid) return;
        await this.UPDATE_BROKERAGE_DATA(this.localBrokerageData);
        this.$emit("finish-saving", true);
        this.$set(this, "initialBrokerageData", cloneDeep(this.localBrokerageData));
        this.$v.$reset();
        if (this.settingsType === "personal-settings" && this.localBrokerageData.subdomain !== this.brokerageData.subdomain) {
          location.pathname = this.localBrokerageData.subdomain;
        }
        if (this.settingsType === "brokerage-settings") {
          this.SET_BROKERAGE_SUBDOMAIN(this.localBrokerageData.subdomain);
        }
        showToast("success", "informationUpdatedSuccessfully");
      } catch (e) {
        this.$emit("finish-saving", false);
      }
    }
  })
});